import { CardContent, Collapse, Unstable_Grid2 as Grid } from '@mui/material';

import {
  Typography,
  Paper,
  Switches,
  TextField,
  CardHeader,
  IconAvatar,
  LocalGasStationOutlinedIcon,
} from '@occc-app/design-system';

import { PromptAtPumpFormValues } from './types';

export type PromptAtPumpProps = {
  values: PromptAtPumpFormValues;
  description?: string;
};

export const PromptAtPump = ({ values, description }: PromptAtPumpProps) => (
  <Paper>
    <CardHeader
      title={<Typography variant='subtitle1'>Prompt Members at the Pump</Typography>}
      subheader={
        <Typography variant='body2' color='textSecondary'>
          {description ?? 'Ask members at the pump to redeem this offer'}
        </Typography>
      }
      action={<Switches name='promptAtPump.isEnabled' data={{}} />}
      avatar={<IconAvatar Icon={LocalGasStationOutlinedIcon} />}
      sx={{ py: 2, px: 3 }}
    />
    <Collapse in={values.promptAtPump.isEnabled} timeout='auto' unmountOnExit>
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={3}>
          <Grid xs={6}>
            <TextField
              name='promptAtPump.shortPrompt'
              label='Short prompt (max 32 char)'
              margin='normal'
              multiline
            />
          </Grid>

          <Grid xs={6}>
            <TextField
              name='promptAtPump.longPrompt'
              label='Long prompt (max 80 char)'
              margin='normal'
              multiline
            />
          </Grid>
        </Grid>
      </CardContent>
    </Collapse>
  </Paper>
);
